import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import AdminChangeUserByVpsUsComponent from "../../../../components/Admin/vps_us/AdminChangeUserByVpsUsComponent";

const AdminChangeUserVpsUsPage = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <AdminChangeUserByVpsUsComponent
        redirectBack={ () => redirectBack() }
        listVpsId={ new URLSearchParams(search).get('listVpsId') }
    />
}

export default AdminChangeUserVpsUsPage;